/* eslint-disable @typescript-eslint/no-unused-vars */
import { PerfilesId } from "src/utils/perfil";
import { IdocumentosForm } from "./documentos/utils";
import { IExperienciaLaboralForm } from "./experiencia-laboral/utils";
import { IinformacionBasicaForm } from "./informacion-basica/utils";

export const buildData = (informacionBasica: IinformacionBasicaForm, experienciaLaboral: IExperienciaLaboralForm, documentos:IdocumentosForm, aspiranteId: string ) => {
    
    return {
        aspiranteId,
        identificacion: informacionBasica.identificacion,
        tipoIdentificacion: informacionBasica.tipoIdentificacion,
        primerNombre: informacionBasica.primerNombre,
        segundoNombre: informacionBasica.segundoNombre,
        primerApellido: informacionBasica.primerApellido,
        segundoApellido: informacionBasica.segundoApellido,
        fechaNacimiento: informacionBasica.fechaNacimiento,
        sexo: informacionBasica.sexo,
        correoElectronico: informacionBasica.correoElectronico,
        numeroCelular: informacionBasica.numeroCelular,
        departamentoResidenciaId: informacionBasica.departamentoResidenciaId,
        municipioResidenciaId: informacionBasica.municipioResidenciaId,
        perfilId: informacionBasica.perfilId,
        documentoIdentidadAdjuntoId: documentos.documentoIdentidadAdjuntoId,
        tarjetaProfesionalAdjuntoId: documentos.tarjetaProfesionalAdjuntoId,
        certificadoContraloriaAdjuntoId: documentos.certificadoContraloriaAdjuntoId,
        certificadoProcuraduriaAdjuntoId: documentos.certificadoProcuraduriaAdjuntoId,
        certificadoPoliciaNacionalAdjuntoId: documentos.certificadoPoliciaNacionalAdjuntoId,
        certificadoRnmcAdjuntoId: documentos.certificadoRnmcAdjuntoId,
        documentoIdentidadAdjuntoFecha: documentos.documentoIdentidadAdjuntoFecha,
        tarjetaProfesionalAdjuntoFecha: documentos.tarjetaProfesionalAdjuntoFecha,
        certificadoContraloriaAdjuntoFecha: documentos.certificadoContraloriaAdjuntoFecha,
        certificadoProcuraduriaAdjuntoFecha: documentos.certificadoProcuraduriaAdjuntoFecha,
        certificadoPoliciaNacionalAdjuntoFecha: documentos.certificadoPoliciaNacionalAdjuntoFecha,
        certificadoRnmcAdjuntoFecha: documentos.certificadoRnmcAdjuntoFecha,
        certificadoAntecedentesDisciplinariosId: documentos.certificadoAntecedentesDisciplinariosId,
        certificadoAntecedentesDisciplinariosFecha: documentos.certificadoAntecedentesDisciplinariosFecha,
        hojaDeVidaAdjuntoId: documentos.hojaDeVidaAdjuntoId,
        fechaExpedicionTarjetaProfesional: informacionBasica.fechaExpedicionTarjetaProfesional,
        horariosDisponibles: informacionBasica.horariosDisponibles,
        sedesDisponibles: informacionBasica.sedesDisponibles,
        formacionesAcademicas: [{
            nivelFormacion: informacionBasica.perfilId === PerfilesId.MONITOR? informacionBasica.nivelFormacion : 'PROFESIONAL',
            nombrePrograma: informacionBasica.nombrePrograma,
            nombreInstitucion: informacionBasica.nombreInstitucion,
            fechaGraduacion: informacionBasica.fechaGraduacion,
            soporteId: informacionBasica.soporteId
        }],
        experienciasLaborales: experienciaLaboral.experienciasLaborales
    }
}